<template>
  <div class="filter">{{ $t('Тип запроса') }}<v-select
        v-model="searchParams['event.event.id']"
        :placeholder="$t('Тип запроса')"
        :items="apiList"
        :list-props="{ class: 'api-events-page-select-filter-list' }"
        item-title="name"
        item-value="id"
        hide-details
        variant="solo"
        :disabled="!apiList.length"
    />
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue';
import api from '@/api';
import { toast } from '@/lib/toast';

const { searchParams } = defineProps({
  searchParams: {
    type: Object,
    required: true,
  },
});

const apiList = ref([]);

onMounted(async () => {
  try {
    const { results } = await api.get('/api/vocab/event', { code: 'api/' });
    apiList.value = results;
  } catch (e) {
    toast.error(e.message);
  }
});
</script>

<style scoped>
.filter {
  max-width: 253px;
  min-width: 132px;
}
</style>
